import { createFileRoute, useNavigate } from '@tanstack/react-router';
import {
  CatalogImportScreen,
  type CatalogSearch,
} from '@/features/vendor-catalogs/CatalogImportScreen';
import type { CatalogStatus } from '@/features/vendor-catalogs/types';

/**
 * Vendor catalogs (INC-12a, TASK-0235). Un-nested (`vendors_`) so it does not inherit the
 * `/vendors` list's search schema, like `purchasing_.guide.tsx`.
 */
const STATES = new Set<string>([
  'open',
  'all',
  'uploaded',
  'needs_mapping',
  'needs_go',
  'reading',
  'paused',
  'matching',
  'review',
  'applied',
  'superseded',
  'discarded',
  'failed',
]);

export const Route = createFileRoute('/_app/vendors_/catalogs')({
  staticData: { crumb: 'Catalogs & price lists' },
  validateSearch: (s: Record<string, unknown>): CatalogSearch => ({
    id: Number(s.id) > 0 ? Number(s.id) : undefined,
    state:
      typeof s.state === 'string' && STATES.has(s.state)
        ? (s.state as 'open' | 'all' | CatalogStatus)
        : undefined,
    page: Number(s.page) > 0 ? Number(s.page) : undefined,
    vendorId: Number(s.vendorId) > 0 ? Number(s.vendorId) : undefined,
    q: typeof s.q === 'string' && s.q !== '' ? s.q : undefined,
  }),
  component: VendorCatalogsRoute,
});

function VendorCatalogsRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <CatalogImportScreen
      search={search}
      setSearch={(next) => void navigate({ search: (prev) => ({ ...prev, ...next }) })}
    />
  );
}
